<template>
    <el-dialog
        title="计算规则"
        :visible="value"
        width="60%"
        :beforeClose="close"
    >
        <el-form label-position="top">
            <el-form-item label="计算符号">
                <el-button type="info" @click="addCalculation('add')">➕</el-button>
                <el-button type="info" @click="addCalculation('minus')">➖</el-button>
                <el-button type="info" @click="addCalculation('multiply')">✖</el-button>
                <el-button type="info" @click="addCalculation('divide')">➗</el-button>
                <el-button type="info" @click="claerCalculat">清除</el-button>
            </el-form-item>
            <el-form-item label="计算字段">
                <span v-for="(item, index) in calculationRules" :key="index" style="margin-top: 10px; display: inline-block;">
                    <el-select
                        v-model="item.value"
                        placeholder="请选择字段"
                        @change="value => calculatFieldChange(value, index)"
                    >
                    <el-option
                        v-for="(item, index) in allFormItem"
                        :key="index"
                        :label="item.name"
                        :value="item.code"
                    />
                    </el-select>
                    <span style="padding: 0 10px;">{{transOperator(item.operator)}}</span>
                </span>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="calculatFieldConfirm()">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    name: 'ComputeDialog',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        allFormItem: {
            type: Array,
            default: () => []
        },
        operator: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            calculationRules: undefined
        }
    },
    watch: {
        operator: {
            handler(value) {
                this.calculationRules = value
            }
        }
    },
    methods: {
        close() {
            this.$emit('input', false)
        },
        claerCalculat() {
            this.calculationRules = [
                {
                    label: '',
                    value: '',
                    operator: null,
                    next: null
                }
            ]
        },
        transOperator(type) {
            let value
            switch (type) {
                case 'add': {
                    value = '+'
                    break
                }
                case 'multiply': {
                    value = 'x'
                    break
                }
                case 'minus': {
                    value = '-'
                    break
                }
                case 'divide': {
                    value = '÷'
                    break
                }
            }
            return value
        },
        calculatFieldChange(value, index) {
            console.log(value, index)
            const selectItem = this.allFormItem.find(item => item.code === value)
            this.calculationRules[index].label = selectItem.name
            if(index > 0) {
                this.calculationRules[index - 1].next = value
            }
        },
        addCalculation(type) {
            const lastItem = this.calculationRules[this.calculationRules.length - 1]
            lastItem.operator = type
            this.calculationRules.push({
                label: '',
                value: '',
                operator: null,
                next: null
            })
        },
        calculatFieldConfirm() {
            // this.activeData.calculationRules = {
            //     operator: this.calculationRules,
            //     relation: this.calculationRules.map(item => item.value)
            // }
            this.$emit('confirm', {
                operator: this.calculationRules,
                relation: this.calculationRules.map(item => item.value)
            })
            this.close()
        }
    }
}
</script>